import React, { useEffect, useState } from "react";
import { Table, Button, Card, Container, Row, Col, Pagination } from "react-bootstrap";
import { FormsService } from "../../../../service/forms.service";
import { FormPayload } from "../../../../service/types/types";
import { Eye, EyeFill, Link, Pen, Pencil, PencilFill, PenFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

export default function FormsTableArauco() {
  const [forms, setForms] = useState<FormPayload[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // 👈 cantidad de formularios por página
  const navigate = useNavigate();

  useEffect(() => {
    const fetchForms = async () => {
      const data = await FormsService.findAllByOrg("arauco");
      setForms(data);
    };
    fetchForms();
  }, []);

  const handleView = (id: string) => {
    const url = `/arauco/form/${id}`;
    window.open(url, "_blank");
  };

  const handleViewResults = (id: string) => {
    const url = `/arauco/form/${id}/results`;
    navigate(url);
  };

  const handleCopyUrl = (id: string) => {
    const currentUrl = window.location.origin;
    const fullUrl = `${currentUrl}/arauco/form/${id}`;
    navigator.clipboard.writeText(fullUrl);
    alert("URL copiada: " + fullUrl);
  };

  const handleEdit = (id: string) => navigate(`/arauco/form/${id}/edit`);

  // 📌 Calcular datos de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentForms = forms.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(forms.length / itemsPerPage);

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col md={12}>
          <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">📋 Lista de Formularios</h4>
            </Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive className="align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>Requiere Firma</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentForms.map((form) => (
                    <tr key={form.id}>
                      <td>{form.name}</td>
                      <td>
                        {form.isSignRequired ? (
                          <span className="badge bg-success">Sí</span>
                        ) : (
                          <span className="badge bg-secondary">No</span>
                        )}
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center gap-2">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => handleView(form.id)}
                          >
                            <PencilFill className="me-1" /> Completar
                          </Button>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleViewResults(form.id)}
                          >
                            <EyeFill className="me-1" /> Ver resultados
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => handleCopyUrl(form.id)}
                          >
                            <Link className="me-1" /> Copiar URL
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => handleEdit(form.id)}
                          >
                            <Pencil className="me-1" /> Editar
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {forms.length === 0 && (
                    <tr>
                      <td colSpan={3} className="text-center text-muted">
                        No hay formularios disponibles
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>

              {/* 📌 Paginación */}
              {totalPages > 1 && (
                <Pagination className="justify-content-center">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  />
                  {[...Array(totalPages)].map((_, idx) => (
                    <Pagination.Item
                      key={idx + 1}
                      active={idx + 1 === currentPage}
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </Pagination.Item>
                  ))}
                  <Pagination.Next
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  />
                  <Pagination.Last
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                  />
                </Pagination>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}